import React, { useEffect, useState } from "react";
import { Row, Col, Card, Badge } from "react-bootstrap";
import BrokerAccounts from "./BrokerAccounts";
import BrokerLogin from "../../authentication/simple/BrokerLogin";
import DontBrokerAccount from "../../authentication/simple/DontBrokerAccount";
import { useNavigate, useSearchParams } from "react-router-dom";
import SubscriptionCheckModal from "components/common/SubscriptionCheckModal";
import { useSelector } from "react-redux";
import { useToast } from "components/common/custom-toast/Toast";

import StaticIPManagement from "./StaticIPManagement";
import { Tabs } from "antd";

const BrokerAccountsSplitPage = () => {
  const [updateBrokerList, setUpdateBrokerList] = useState(false)
  const accountsRef = React.useRef(null);
  const toast = useToast()
  const [refreshBrokers, setRefreshBrokers] = useState(false)
  const handleBrokerChanged = () => {
    try {
      if (accountsRef.current && accountsRef.current.getBrokerList) {
        accountsRef.current.getBrokerList(true);
      }
    } catch (e) {
      // no-op
    }
    setUpdateBrokerList(true)
    setRefreshBrokers(true)
  };

  const [searchParams] = useSearchParams();
  const view = searchParams.get("view");
  const isLoggedIn = useSelector((state) => state?.user?.isLoggedIn === true);
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("brokers");

  useEffect(() => {
    if (!isLoggedIn) {
      toast.error("Please login to access Algo signals");
      navigate("/authentication/login");
      return;
    }
  }, [isLoggedIn]);

  const items = [
    {
      key: 'brokers',
      label: 'Configured Brokers',
      children: (
        <div className="table-section">
          <Card.Header style={{ paddingBottom: 0, paddingLeft: 0 }}>
            <h5 className="page-title">Configured Brokers</h5>
            <span className="page-subtitle">Manage your connected trading accounts</span>
          </Card.Header>
          <Card.Body style={{ paddingLeft: 0, paddingRight: 0 }}>
            <BrokerAccounts setRefreshBrokers={setRefreshBrokers} ref={accountsRef} setActiveTab={setActiveTab} setUpdateBrokerList={setUpdateBrokerList} updateBrokerList={updateBrokerList} />
          </Card.Body>
        </div>
      )
    },
    {
      key: 'static-ip',
      label: 'Static IP',
      children: (
        <div className="table-section">
          <Card.Header style={{ paddingBottom: 0, paddingLeft: 0 }}>
            <h5 className="page-title">Static IP Management</h5>
            <span className="page-subtitle">Manage your purchased static IPs and broker assignments</span>
          </Card.Header>
          <Card.Body style={{ paddingLeft: 0 }}>
            <StaticIPManagement refreshBrokers={refreshBrokers} setRefreshBrokers={setRefreshBrokers} />
          </Card.Body>
        </div>
      )
    }
  ];


  return (
    <div className="broker-accounts-split-page">
      <Row>
        <Col md={8} xs={12}>
          <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} className="custom-settings-tabs" />
        </Col>
        <Col md={4} xs={12}>
          <div style={{ marginTop: '3.5rem' }}>
            <Card.Header style={{ paddingBottom: 0 }}>
              <h5 className="page-title">Available Brokers</h5>
              <span className="page-subtitle">Connect with your preferred stock broker</span>
            </Card.Header>
            <Card.Body>
              {view === "new" ? (
                <DontBrokerAccount embedded={true} />
              ) : (
                <BrokerLogin autoShow={true} onBrokerChanged={handleBrokerChanged} />
              )}
            </Card.Body>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BrokerAccountsSplitPage;


